import { useState } from 'react'
import {
  TextInput,
  PasswordInput,
  Checkbox,
  Button,
  Paper,
  Title,
  Text,
  Container,
  Stack,
  Alert,
  Image,
  Center,
  Box,
} from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { RoutexTokens } from '@theme/index'
import { logo } from '@assets/logo'

interface LoginProps {
  onLogin: (username: string, password: string, rememberMe: boolean) => Promise<void>
  error?: string | null
}

export function Login({ onLogin, error }: LoginProps) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [localError, setLocalError] = useState<string | null>(null)

  const handleSubmit = async () => {
    if (!email || !password) {
      setLocalError('Preencha email e senha')
      return
    }
    setIsLoading(true)
    setLocalError(null)
    try {
      await onLogin(email, password, rememberMe)
    } catch (e: any) {
      setLocalError(e?.message || 'Erro ao fazer login')
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const displayError = error || localError

  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Gradiente da paleta, nao azul cravado: era o unico lugar do app que ficava
        // fora do tema, e a troca de paleta nao o alcancava.
        background: `linear-gradient(135deg, ${RoutexTokens.amber900} 0%, ${RoutexTokens.amber600} 50%, ${RoutexTokens.amber500} 100%)`,
      }}
    >
      <Container size={420} my={40}>
        <Center mb="xl">
          <Stack gap={4} align="center">
            {/* O logo entra em branco aqui: o fundo desta tela e o proprio gradiente ambar,
                e o simbolo em ambar sobre ambar perderia contraste. Branco tambem casa com o
                wordmark ao lado, que ja e branco. */}
            <Image
              src={logo.mark}
              alt="RouteX"
              w={64}
              h={64}
              fit="contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <Title c="white" order={1} style={{ letterSpacing: '-0.02em' }}>
              RouteX.dev
            </Title>
            <Text c="rgba(255,255,255,0.7)" size="sm">
              Routing Intelligence as a Service
            </Text>
          </Stack>
        </Center>

        <Paper withBorder p={30} radius="md">
          <Title order={3} ta="center" mb="xs">
            Entrar
          </Title>
          <Text c="dimmed" size="sm" ta="center" mb="lg">
            Acesse o painel de administração
          </Text>

          {displayError && (
            <Alert icon={<IconAlertCircle size={16} />} title="Erro" color="red" mb="md" variant="light">
              {displayError}
            </Alert>
          )}

          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="admin@routex.dev"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              onKeyDown={handleKeyDown}
            />

            <PasswordInput
              label="Senha"
              placeholder="Sua senha"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              onKeyDown={handleKeyDown}
            />

            <Checkbox
              label="Lembrar-me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.currentTarget.checked)}
            />

            <Button fullWidth loading={isLoading} onClick={handleSubmit} size="md">
              Entrar
            </Button>
          </Stack>
        </Paper>

        <Text c="rgba(255,255,255,0.5)" size="xs" ta="center" mt="md">
          IntegrAllTech Tecnologia - {new Date().getFullYear()}
        </Text>
      </Container>
    </Box>
  )
}
